/**
 * Our Story timeline — reveal items on scroll
 */
(function () {
  'use strict';

  var list = document.querySelector('[data-story-timeline]');
  if (!list) return;

  var items = list.querySelectorAll('[data-timeline-item]');
  if (!items.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    items.forEach(function (item) {
      item.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.2
    }
  );

  items.forEach(function (item) {
    observer.observe(item);
  });
})();
